import { SettingsPage } from "@/interface/pages/settings-page";
import { SettingsWorkflow } from "@/lib/hooks/settings/use-settings-workflow";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const settingsSearchSchema = z.object({
  tab: z.nativeEnum(SettingsWorkflow).optional(),
  // TanStack can surface query values as number 1 from ?payment_method_updated=1
  payment_method_updated: z
    .union([z.literal("1"), z.literal(1)])
    .optional()
    .transform((v) => (v === undefined ? undefined : "1")),
});

export const Route = createFileRoute("/_authenticated/_active-subscription/users/settings")({
  validateSearch: settingsSearchSchema,
  component: RouteComponent,
});

function RouteComponent() {
  return <SettingsPage />;
}
